import React, { Component } from "react";
import Datas from "../data/footer/footer.json";
import { Link } from "react-router-dom";
import { Container, Row, Col } from "react-bootstrap";
import BackToTop from "./common/BackToTop";
import { Styles } from "./styles/footerOne.js";
import axios from "axios";
import { Constant, imageDomain } from "../helper/Constants.js";

class Footer extends Component {
  state = {
    all_blogs: [],
    loadingBlogs: false,
    errorBlogs: null,
    socialLinks: [],
  };

  componentDidMount() {
    this.fetchAllBlogs();
    this.fetchSocialLinks();
  }

  fetchSocialLinks = async () => {
    try {
      const url = Constant?.getUrls?.getAllSocialMedia;
      if (!url) return;

      const resp = await axios.get(url);
      console.log(resp);
      
      this.setState({
        socialLinks: resp?.data?.data || [],
      });
    } catch (error) {
      console.error("Failed to fetch social links", error);
    }
  };

  fetchAllBlogs = async () => {
    try {
      const url = Constant?.getUrls?.getAllBlogs;

      if (!url) {
        console.error("Blogs API URL not configured");
        this.setState({ loadingBlogs: false });
        return;
      }

      this.setState({ loadingBlogs: true, errorBlogs: null });

      const resp = await axios.get(url);
      const blogs = resp?.data?.data;
      // console.log(blogs, " ------------- blogs ");

      this.setState({ all_blogs: blogs, loadingBlogs: false }, () => {
        this.renderRecentPosts();
      });

      // if (Array.isArray(blogs)) {
      // } else {
      //   this.setState({ loadingBlogs: false });
      // }
    } catch (error) {
      // console.error("Failed to fetch blogs:", error);
      this.setState({
        errorBlogs: error.message || "Failed to fetch",
        loadingBlogs: false,
      });
    }
  };

  // Resolve image URL properly
  getImageUrl = (poster) => {
    if (!poster) return "";
    if (poster.startsWith("http://") || poster.startsWith("https://"))
      return poster;
    if (process.env.PUBLIC_URL && poster.startsWith("/"))
      return process.env.PUBLIC_URL + poster;
    if (imageDomain) {
      return imageDomain.replace(/\/+$/, "") + "/" + poster.replace(/^\/+/, "");
    }
    return (
      (process.env.PUBLIC_URL || "") +
      (poster.startsWith("/") ? poster : "/" + poster)
    );
  };

  renderRecentPosts = () => {
    const { all_blogs, loadingBlogs, errorBlogs } = this.state;

    // Loading & error states (optional UI)
    // if (loadingBlogs) {
    //   return <p>Loading recent posts...</p>;
    // }

    if (errorBlogs) {
      // You can hide this in production if you want
      return <p style={{ color: "red" }}>{errorBlogs}</p>;
    }

    // Pick first 3 blogs that actually have an image
    const blogsWithImages = (all_blogs || [])
      .map((b) => {
        const poster =
          b.poster ||
          b.image ||
          b.thumbnail ||
          b.featured_image ||
          b.cover_image ||
          b.blog_image;

        if (!poster) return null;

        return {
          ...b,
          _resolvedPoster: this.getImageUrl(poster),
        };
      })
      .filter((b) => b && b._resolvedPoster)
      .slice(0, 3);

    console.log(" map function called");

    // If no blogs with images, fallback to the static ones you had earlier

    return this.state.all_blogs.slice(0, 2).map((blog, idx) => {
      const title =
        blog.title || blog.blogs_title || blog.name || "Untitled blog";
      const date =
        blog.published_at ||
        blog.createdAt ||
        blog.date ||
        blog.blogs_date ||
        "";
      // Adjust route according to your actual blog details route
      const detailPath =
        blog.slug || blog.id
          ? `/blog-details/${blog.slug || blog.id}`
          : "/blog-details";

      return (
        <div className="post-box d-flex" key={idx}>
          <div className="post-img">
            <img src={imageDomain + blog.blogs_poster} alt={title} />
          </div>
          <div className="post-content">
            <Link to={process.env.PUBLIC_URL + detailPath}>{title}</Link>
            <span>{date}</span>
          </div>
        </div>
      );
    });
  };

  render() {
    return (
      <Styles>
        {/* Footer Area */}
        <footer
          className="footer1"
          style={{
            backgroundImage: `url(${
              process.env.PUBLIC_URL + "/assets/images/" + Datas.backgroundImage
            })`,
          }}
        >
          <Container>
            <Row>
              <Col md="4">
                <div className="footer-logo-info">
                  <img
                    src={process.env.PUBLIC_URL + "/assets/images/logo.png"}
                    alt=""
                    className="img-fluid"
                  />
                  <p>Your one stop solution for the Mathematics</p>
                  <ul className="list-unstyled">
                    <li>
                      <i className="las la-map-marker"></i>PL.NO. 42/43, F. NO.
                      301 GAURI APPARTMENT UTKARSHA SOCIETY, DABHA, NAGPUR,
                      Maharashtra, India, 440023
                    </li>
                    <li>
                      <i className="las la-envelope"></i>
                      vasaicompdigilearn@gmail.com
                    </li>
                    <li>
                      <i className="las la-phone"></i>+91 9422690015 | +91
                      9423110012
                    </li>
                  </ul>
                </div>
              </Col>

              <Col md="4">
                <div className="f-links">
                  <h5>Useful Links</h5>
                  <ul className="list-unstyled">
                    <li>
                      <Link to={process.env.PUBLIC_URL + "/about"}>
                        <i className="las la-angle-right"></i>About Us
                      </Link>
                    </li>
                    <li>
                      <Link to={process.env.PUBLIC_URL + "/blogs"}>
                        <i className="las la-angle-right"></i>Our Blogs
                      </Link>
                    </li>
                    <li>
                      <Link to={process.env.PUBLIC_URL + "/course-grid"}>
                        <i className="las la-angle-right"></i>Our Courses
                      </Link>
                    </li>
                    <li>
                      <Link to={process.env.PUBLIC_URL + "/events"}>
                        <i className="las la-angle-right"></i>Events
                      </Link>
                    </li>
                    <li>
                      <Link to={process.env.PUBLIC_URL + "/gallery"}>
                        <i className="las la-angle-right"></i>Gallery
                      </Link>
                    </li>
                  </ul>
                </div>
              </Col>

              <Col md="4">
                <div className="f-post">
                  <h5>Recent Post</h5>
                  {this.renderRecentPosts()}
                </div>
              </Col>
            </Row>
          </Container>
        </footer>

        {/* Copyright Area */}
        <section className="copyright-area">
          <Container>
            <Row>
              <Col md="6">
                <div className="copy-text">
                  <p>
                    Copyright &copy; 2020 | Designed With{" "}
                    <i className="las la-heart"></i> by{" "}
                    <a
                      href={process.env.PUBLIC_URL + "/"}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      The Space Element
                    </a>
                  </p>
                </div>
              </Col>
              <Col md="6" className="text-right">
                {/* <ul className="social list-unstyled list-inline text-center"> */}
                  {this.state.socialLinks.map((item) => (
                    <li className="list-inline-item px-2 text-center" key={item._id} >
                      <a
                        href={item.url}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <img
                          src={imageDomain + item.icon}
                          alt="social"
                          className="ml-3"
                          style={{
                            // marginLeft: 10,
                            width: "30px",
                            height: "30px",
                            objectFit: "contain",
                          }}
                        />
                      </a>
                    </li>
                  ))}
                {/* </ul> */}

                {/* <ul className="social list-unstyled list-inline">
                  <li className="list-inline-item">
                    <a href={process.env.PUBLIC_URL + "/"}>
                      <i className="fab fa-facebook-f"></i>
                    </a>
                  </li>
                  <li className="list-inline-item">
                    <a href={process.env.PUBLIC_URL + "/"}>
                      <i className="fab fa-twitter"></i>
                    </a>
                  </li>
                  <li className="list-inline-item">
                    <a href={process.env.PUBLIC_URL + "/"}>
                      <i className="fab fa-linkedin-in"></i>
                    </a>
                  </li>
                  <li className="list-inline-item">
                    <a href={process.env.PUBLIC_URL + "/"}>
                      <i className="fab fa-youtube"></i>
                    </a>
                  </li>
                  <li className="list-inline-item">
                    <a href={process.env.PUBLIC_URL + "/"}>
                      <i className="fab fa-dribbble"></i>
                    </a>
                  </li>
                </ul> */}
              </Col>
            </Row>
          </Container>

          {/* Back To Top */}
          <BackToTop />
        </section>
      </Styles>
    );
  }
}

export default Footer;
